<template>
  <b-row v-if="parentPath && path" style="height:100%;">
    <b-col md="12" style="height:100%;">
      <b-card
        v-tooltip="uniToolTipTranslation('S448', 'en-US')"
        class="card-panel"
        :header="uniTranslation('S448')"
        style="height:100%; margin-bottom: 0px !important"
        :style="{ backgroundColor: coloreSfondo }"
      >
        <UnidataEditorCorrelatorOptionList :parent-path="path" group="AirFace">
        </UnidataEditorCorrelatorOptionList>

        <UnidataEditor :parent-path="path" :name="'.inletTemperatureDB'"> </UnidataEditor>

        <UnidataEditorCorrelator :parent-path="path" group="InletHumidityTemperatureCorrelation">
        </UnidataEditorCorrelator>

        <UnidataEditor :parent-path="path" :name="'.outletTemperatureDB'"> </UnidataEditor>

        <UnidataEditorCorrelator :parent-path="path" group="OutletHumidityTemperatureCorrelation">
        </UnidataEditorCorrelator>

        <UnidataEditor :parent-path="path" :name="'.foulingFactor'"> </UnidataEditor>

        <UnidataEditor :parent-path="path" :name="'.pressureDrop'"> </UnidataEditor>

        <!-- 
          <el-collapse accordion >
            <el-collapse-item name="airSideAdvancedAccordion">
              <template slot="title"> {{uniTranslation('S1636')}}
              </template>
              <unidata-editor-correlator  :parentPath="path" group="AtmosphericGroup">
              </unidata-editor-correlator>

              <unidata-editor-correlator  :parentPath="path" group="AirDensityGroup">
              </unidata-editor-correlator>

            </el-collapse-item>
          </el-collapse>
          -->
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import UnidataEditor from "../unidata/UnidataEditor";
import UnidataEditorCorrelator from "../unidata/UnidataEditorCorrelator";
import UnidataEditorCorrelatorOptionList from "../unidata/UnidataEditorCorrelatorOptionList";
import { mapGetters } from "vuex";
import colorsService from "../../services/backend/colorsService";
// import { Radio, Collapse, CollapseItem } from "element-ui";
// import jsonHelper from "../../shared/jsonHelper";

export default {
  components: {
    UnidataEditor,
    UnidataEditorCorrelator,
    UnidataEditorCorrelatorOptionList /*,
    "el-radio": Radio,
    "el-collapse": Collapse,
    "el-collapse-item": CollapseItem*/
  },
  props: {
    parentPath: {
      type: String,
      required: true
    },
    localPath: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      path: null,
      coloreSfondo: ""
    };
  },
  computed: {
    ...mapGetters("_prjModule", ["projects"]),
    ...mapGetters("_colorsModule", ["cardColors"])
  },
  watch: {
    parentPath: function(nv /*, ov*/) {
      if (nv !== undefined && nv !== null && nv !== "") {
        this.path = this.parentPath + this.localPath;
      }
    }
  },
  mounted: function() {
    if (this.parentPath && this.localPath) this.path = this.parentPath + this.localPath;
    var that = this;
    that.coloreSfondo = that.cardColors[0] + " !important";
  },
  methods: {}
};
</script>

<style lang="scss">
div {
  hr {
    margin-bottom: 10px;
    margin-top: 0;
  }
  .radio-unidata {
    display: flex;
    flex-direction: row;
    .radio-container {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding-top: 25px;
      padding-left: 10px;
      width: 160px;
      label {
        margin-bottom: 0px;
      }
      .el-radio + .el-radio {
        margin-left: 0px;
      }
    }
  }
}
</style>
